/* eslint-disable max-statements */
import { WorkCenter } from 'models/workcenters';
import { UiCommands } from './UiCommands';

export async function changeRevisionCodeCommand(
  this: UiCommands,
  revisionCode: string
) {
  this.uiState.isScreenLoading = true;
  this.setUiStateTriggerReRender(this.uiState);

  // guaranteed to have a match based on ui code
  const currentRevisionCode = this.uiState.revisionCodes.filter(
    (revCode) => revCode.code === revisionCode
  )[0];

  const apiCalls = [this.apis.getWorkCenters()];
  const results = await Promise.allSettled(apiCalls);
  this.uiState.isScreenLoading = false;

  const errorResults = results.filter((r) => {
    return (r as PromiseRejectedResult).reason;
  });
  if (errorResults.length > 0) {
    this.uiState.screenError = 'Error loading revision code';
    this.setUiStateTriggerReRender(this.uiState);
    return;
  }

  const workCentersResult = results[0] as PromiseFulfilledResult<WorkCenter[]>;
  this.uiState.isScreenLoading = false;

  this.buildViewModel(currentRevisionCode, workCentersResult.value);
}
